import type { IconData } from '@stacksjs/iconify-core'

export const folderZip: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10.83 2H17a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h5c1.306 0 2.417.835 2.83 2M17 4H9.415l-.471-1.334A1 1 0 0 0 8 2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m-3 2h2v2h-2zm-2-2h2v2h-2zm0 4h2v2h-2zm2 2h2v2h-2zm-2 2h2v2h-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default folderZip
